<template>
  <div>
    <purchases :id="order.id" @input="uploadProduct" :order="order"/>
    <promotions :order="order" :partner="partner"  />
    <hr />

    <div v-if="transaction.limit < order.price_total">
      <h1>Лимит не проходит</h1>
    </div>

    <div v-else>
      <button class="btn btn-info mt-5" @click="uploadProduct">
        {{ "upload_product" | setText("Выгрузить товары") }}
      </button>

      <div v-if="products.length">
        <small>
          {{ "uploaded_products" | setText("Выгрузились товары") }}:
          <div v-for="(product, key) in products" :key="key">
            {{ key + 1 }}. {{ product.title }}
          </div>
        </small>
      </div>

      <div class="install-control">
        <button
          @click="send"
          :disabled="products.length != qty"
          class="btn btn-success"
        >
          {{ "next_step" | setText("Далее") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  computed: {
    qty() {
      return this.order.purchases.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.quantity;
      }, 0);
    },
  },
  components: {
    purchases: () => import("@/components/Item/Order/Purchases"),
    promotions: () => import("@/components/Item/Order/Promotions"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    async uploadProduct() {
      this.products = await [];
      this.$loading(true);
      if (this.order && this.order.purchases) {
        for (let i = 0; i < this.order.purchases.length; i++) {
          await this.$http({
            url: `${this.partner["endpoint_url"]}catalog/product/item/create`,
            method: "POST",
            data: {
              title: this.order.purchases[i]["name"],
              category_id: 1,
              sku: this.order.purchases[i]["barcode"],
              class_code: this.order.purchases[i]["code"]
                ? this.order.purchases[i]["code"]
                : "08517001001000000",
              amount: this.order.purchases[i]["price"],
            },
            headers: {
              Authorization: `${
                this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
              }${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          })
            .then((response) => {
              for (let j = 0; j < this.order.purchases[i]["quantity"]; j++) {
                this.products.push({
                  id: response.data.data.product_id,
                  quantity: 1,
                  title: this.order.purchases[i]["name"],
                });
              }
            })
            .catch((error) => {
              errorNotify(error, this.$notify);
            });
        }
      }

      this.$loading(false);
    },

    async send() {
      let data = {
        app_id: this.transaction.exchange_id
          ? this.transaction.exchange_id
          : this.value.data.app_id,

        products: this.products,
        pre_payment: 0,
        period: 12,
      };

      console.log(data);

      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}contract/purchase`,
        method: "POST",
        data: data,
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            this.$emit("setStep", "contract-upload-photo");
            this.$emit("input", response.data);
            this.createTransaction({
              step: "contract-upload-photo",
            });
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          // this.$emit("setStep", "contract-upload-photo"); //test

          setTimeout(() => {
            this.$loading(false);
          }, 500);
        });
    },
  },
  data() {
    return {
      products: [],
    };
  },
};
</script>

